import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const P = styled.p<{
  $mt?: number
  $mb?: number
  $ml?: number
  $fontSize?: string
  $fontStyle?: string
  $fontWeight?: string
}>`
  font-size: ${({ $fontSize }) => $fontSize || '14px'};
  font-style: ${({ $fontStyle }) => $fontStyle || 'normal'};
  font-weight: ${({ $fontWeight }) => $fontWeight || '400'};
  ${({ $mt }) => $mt && `margin-top: ${$mt}px`};
  ${({ $mb }) => $mb && `margin-bottom: ${$mb}px`};
  ${({ $ml }) => $ml && `margin-left: ${$ml}px`};
`

export const QuestionnaireH3 = styled.h3`
  font-size: 16px;
  font-weight: 600;
`

export const QuestionnaireAcceptanceContainer = styled.div<{
  $isAccepted: boolean
}>`
  cursor: default;
  display: flex;
  flex-direction: row;
  margin: 0.5em;
  margin-left: 0;
  padding: 4px 8px;
  border-radius: 20px;
  min-width: 120px;
  width: fit-content;
  display: inline-block;
  text-align: left;
  font-size: 12px;
  font-weight: 400;
  color: ${palette.neutral[800]};

  border: 1px solid;
  border-color: ${({ $isAccepted }) =>
    $isAccepted ? palette.green[500] : palette.orange[500]};

  background-color: ${({ $isAccepted }) =>
    $isAccepted ? palette.green[50] : palette.orange[50]};
`

export const QuestionnaireContextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
